const BASE = process.env.VUE_APP_ENV === 'preview' ? 'api/gp-order-staging' : 'api/gp-order'
const urls = {
  /*
  * body
  *   tgId
  *   userId
  * */
  bindTgUser: 'get /api/order/investAdvisor/relateUserAndTgId',

  /*
  * 投顾拉新-用户数据
  * body
  *   (tgId) [nickName] [phone] [authorName] [page] [limit]
  * */
  tgUserlist: 'get /api/order/investAdvisor/getUsersInfo',
  tgPayslist: 'get /api/order/investAdvisor/getTgInfoDetail',
  tgInfo: 'get /api/order/investAdvisor/getTagInfo',

  // 投顾数据统计
  tgUserTotal: 'get /api/order/investAdvisor/tgStat'
}

const URLS = {}
for (let k in urls) {
  const arr = urls[k].split(' ')
  URLS[k] = `${arr[0]} ${BASE}${arr[1]}`
}

export default URLS
